module.exports = "/_next/static/images/search_bg_1-7e487727fb6a56e47ff2bb42ca850ac1.jpg";